import { createSlice } from '@reduxjs/toolkit';

interface RecaptchaState {
    loaded: boolean;
}

const initialState: RecaptchaState = {
    loaded: false,
};

const recaptchaSlice = createSlice({
    name: 'recaptcha',
    initialState,
    reducers: {
        setRecaptchaLoaded: (state, action) => {
            state.loaded = action.payload;
        },
    },
});

export const { setRecaptchaLoaded } = recaptchaSlice.actions;
export default recaptchaSlice.reducer;